
/* System defined core library */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


//import { PipeModule } from '../shared/modules/pipes.module';

import { ProgramInformationRoutingModule } from './program-information.routing';
import { SharedModule } from '../../../shared/modules/shared.module';


import { ProgramInformationComponent } from '../../schedule-appointment/program-information/program-information.component';

@NgModule({
    imports: [
        CommonModule,
        ProgramInformationRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        TranslateModule,
        TranslateModule.forChild({})
    ],
    providers: [],
    declarations: [
        ProgramInformationComponent
    ],
    exports: [
        ProgramInformationComponent
    ]
})
export class ProgramInformationModule { }
